import Immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState, onReadValue } from 'redux-recompose';

import { CANCEL_REQUEST_ERROR } from '~constants/apiErrors';

import { actions, targets } from './actions';
import { REJECTED_ORDERS_TAB_NAMES } from './constant';
import { onRejectedOrdersUpdate } from './effects';

const stateDescription = {
  [targets.ACTIVE_TAB]: REJECTED_ORDERS_TAB_NAMES.rejectedOrders,
  [targets.REJECTED_ORDERS]: {
    page: []
  },
  [targets.NEW_ORDERS]: [],
  [targets.FILTERS]: { orderAge: '24' }
};

const initialState = completeState(stateDescription);

const reducerDescription = {
  primaryActions: [
    actions.SET_ACTIVE_TAB,
    actions.GET_REJECTED_ORDERS,
    actions.ADD_NEW_ORDER,
    actions.ASSIGN_ORDER,
    actions.NEW_ASSIGNED_ORDER,
    actions.SET_FILTERS,
    actions.SET_SELECTED_ORDER,
    actions.INJECT_ORDER,
    actions.GET_NEW_ORDER_REJECTED_ORDER
  ],
  override: {
    [actions.SET_ACTIVE_TAB]: onReadValue(),
    [actions.SET_FILTERS]: onReadValue(),
    [actions.ADD_NEW_ORDER]: (state, { payload }) => {
      if (
        !payload ||
        state[targets.REJECTED_ORDERS].page.some(({ id }) => id === payload?.id) ||
        state[targets.REJECTED_ORDERS].currentPage > 1
      ) {
        return state;
      }

      return state.merge({
        ...state,
        [targets.REJECTED_ORDERS]: {
          ...state[targets.REJECTED_ORDERS],
          page: [payload, ...state[targets.REJECTED_ORDERS].page],
          totalCount: state[targets.REJECTED_ORDERS].totalCount + 1
        },
        [targets.NEW_ORDERS]: [payload, ...state[targets.NEW_ORDERS]]
      });
    },
    [actions.GET_REJECTED_ORDERS_FAILURE]: (state, { payload }) => {
      if (payload === CANCEL_REQUEST_ERROR) {
        return state.merge({ ...state, rejectedOrdersLoading: true });
      }
      return state.merge({ ...state, rejectedOrdersLoading: false });
    },
    [actions.NEW_ASSIGNED_ORDER]: onRejectedOrdersUpdate(),
    [actions.ASSIGN_ORDER_SUCCESS]: onRejectedOrdersUpdate(),
    [actions.SET_SELECTED_ORDER]: (state, { payload }) =>
      state.merge({ ...state, [targets.SELECTED_ORDER]: payload }),
    [actions.REMOVE_INJECTED_ORDER]: (state, { payload }) => {
      const rejectedOrders = state[targets.REJECTED_ORDERS]?.page.filter(({ id }) => id !== payload.id);
      return state.merge({
        ...state,
        [targets.REJECTED_ORDERS]: {
          ...state[targets.REJECTED_ORDERS],
          page: rejectedOrders,
          totalCount: state[targets.REJECTED_ORDERS].totalCount - 1
        }
      });
    }
  }
};

export default createReducer(new Immutable(initialState), completeReducer(reducerDescription));
